import { Component, Inject, LOCALE_ID, Renderer2, NgModule, Injectable, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router'
import { AuthService } from './auth.service';
import {Amplify} from 'aws-amplify';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})

@Injectable()
export class AppComponent implements OnInit {

  public environment = environment;

   title = environment.theme.title;
  constructor(public projectTitle: Title, public router: Router, public auth: AuthService, private route: ActivatedRoute, private translate: TranslateService){

    // Set page title based on current project
    this.projectTitle.setTitle(environment.theme.title);
    
    // Apply theme based on current project
    this.changeTheme(environment.theme.themeColourScheme);

    // Apply font family
    if (environment.theme.fontFamily) {
      document.documentElement.style.setProperty('--app-font-family', environment.theme.fontFamily);
      document.body.style.fontFamily = environment.theme.fontFamily;
    }
  }

  async ngOnInit() {
    // Initialize translation service with persistence
    const savedLang = localStorage.getItem('selectedLanguage') || 'en';
    this.translate.setDefaultLang('en');
    this.translate.use(savedLang);
    
    // Save language preference when it changes
    this.translate.onLangChange.subscribe((event) => {
      localStorage.setItem('selectedLanguage', event.lang);
    });
    
    const cognitoConfig = environment.cognito;
    
    Amplify.configure({
      Auth: {
        Cognito: {
          userPoolClientId: cognitoConfig.userPoolClientId,
          userPoolId: cognitoConfig.userPoolId,
          loginWith: {
            username: true,
            email: false,
            phone: false,
          },
        }
      }});
    await this.auth.isLoggedIn();
    this.setFavicon();
  }

  changeTheme(colors: string[]) {
    const [base, background, baseVariant, baseVariantDark, primaryDark, primaryDarkVariant,
           primaryLight, secondaryDark, secondaryLight, shadow, warn, baseTextDark, baseTextLight,
           primaryText, baseLightVariant, baseAltText, baseAltTextSec, baseLoginBackground, notificationSuccess,
           notificationWarning, notificationError, baseTextAltDark, backgroundRegistration, hoverBtnBg, backgroundMedGrey,
           sideNavIconFill, secondaryBackground, tertiaryBackground, tabFill, tertiaryText] = colors;
            document.documentElement.style.setProperty('--base', base);
            document.documentElement.style.setProperty('--background', background);
            document.documentElement.style.setProperty('--base-variant', baseVariant);
            document.documentElement.style.setProperty('--base-variant-dark', baseVariantDark)
            document.documentElement.style.setProperty('--primary-dark', primaryDark);
            document.documentElement.style.setProperty('--primary-dark-variant', primaryDarkVariant);
            document.documentElement.style.setProperty('--primary-light', primaryLight);
            document.documentElement.style.setProperty('--secondary-dark', secondaryDark);
            document.documentElement.style.setProperty('--secondary-light', secondaryLight);
            document.documentElement.style.setProperty('--shadow', shadow);
            document.documentElement.style.setProperty('--warn', warn);
            document.documentElement.style.setProperty('--base-text-dark', baseTextDark);
            document.documentElement.style.setProperty('--base-text-light', baseTextLight);
            document.documentElement.style.setProperty('--primary-text', primaryText);
            document.documentElement.style.setProperty('--base-light-variant', baseLightVariant);
            document.documentElement.style.setProperty('--base-alt-text', baseAltText);
            document.documentElement.style.setProperty('--base-alt-text-secondary', baseAltTextSec);
            document.documentElement.style.setProperty('--base-login-background', baseLoginBackground);
            document.documentElement.style.setProperty('--notification-success', notificationSuccess);
            document.documentElement.style.setProperty('--notification-warning', notificationWarning);
            document.documentElement.style.setProperty('--notification-error', notificationError);
            document.documentElement.style.setProperty('--base-text-alt-dark', baseTextAltDark);
            document.documentElement.style.setProperty('--background-registration', backgroundRegistration);
            document.documentElement.style.setProperty('--hover-btn-bg', hoverBtnBg);
            document.documentElement.style.setProperty('--background-med-grey', backgroundMedGrey);
            document.documentElement.style.setProperty('--side-nav-icon-fill', sideNavIconFill);
            document.documentElement.style.setProperty('--secondary-background', secondaryBackground);
            document.documentElement.style.setProperty('--tertiary-background', tertiaryBackground);
            document.documentElement.style.setProperty('--tab-fill', tabFill);
            document.documentElement.style.setProperty('--tertiary-text', tertiaryText);

            // M3 system tokens — needed for Material components
            document.documentElement.style.setProperty('--mat-sys-primary', primaryDark);
            document.documentElement.style.setProperty('--mat-sys-on-primary', baseTextLight);
            document.documentElement.style.setProperty('--mat-sys-surface', background);
            document.documentElement.style.setProperty('--mat-sys-on-surface', baseTextDark);
            document.documentElement.style.setProperty('--mat-sys-outline', baseVariantDark);
  }

  setFavicon(): void {
    const favicon = document.getElementById('favicon') as HTMLLinkElement;
    if (favicon) {
      favicon.href = environment.theme.favicon;
    }
  }
}
